import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-payment-registration',
  templateUrl: './payment-registration.component.html',
  styleUrls: ['./payment-registration.component.scss']
})
export class PaymentRegistrationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
